export const AUTH_ID_TOKEN_KEY = 'cognito_id_token';
export const AUTH_ACCESS_TOKEN_KEY = 'cognito_access_token';
export const AUTH_REFRESH_TOKEN_KEY = 'cognito_refresh_token';

export const saveTokens = (
  idToken: string,
  accessToken: string,
  refreshToken?: string
) => {
  localStorage.setItem(AUTH_ID_TOKEN_KEY, idToken);
  localStorage.setItem(AUTH_ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    localStorage.setItem(AUTH_REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const getIdToken = (): string | null => {
  return localStorage.getItem(AUTH_ID_TOKEN_KEY);
};

export const getAccessToken = (): string | null => {
  return localStorage.getItem(AUTH_ACCESS_TOKEN_KEY);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(AUTH_REFRESH_TOKEN_KEY);
};

export const clearTokens = () => {
  localStorage.removeItem(AUTH_ID_TOKEN_KEY);
  localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY);
  localStorage.removeItem(AUTH_REFRESH_TOKEN_KEY);
};

export const isTokenValid = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};

export const getTokenPayload = (token: string) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};
